import type {BuildTypes, ProblemOccurrence} from '../../../../services/rest'
import type {ProjectId} from '../../../../types'
import {UserProperties} from '../../../../utils/userProperties'
import ModeSwitch, {Mode} from '../../../common/ModeSwitch/ModeSwitch'
import BuildProblems from '../../../packages/Problems/BuildProblems/BuildProblems'
import BuildTypeProblems from '../../../packages/Problems/BuildTypeProblems/BuildTypeProblems'
import {
  BUILD_CONFIGURATION_PROBLEMS_TAB_LABEL,
  BUILD_PROBLEMS_TAB_LABEL,
  Problems,
  TESTS_TAB_LABEL,
} from '../../../packages/Problems/Problems.types'
import TestProblems from '../../../packages/Problems/TestProblems/TestProblems'

import styles from './ProjectProblemsTab.css'

type Props = {
  projectId: ProjectId

  //TODO remove
  buildProblems?: ProblemOccurrence[]
  buildTypes?: BuildTypes[]
}

function ProjectProblemsTab({projectId, buildProblems, buildTypes}: Props) {
  return (
    <>
      <ModeSwitch
        userProperty={UserProperties.PROJECT_PROBLEMS_MODE}
        preserveParams={({projectTab}) => ({projectTab})}
        headerClassName={styles.header}
      >
        <Mode mode={Problems.TESTS} label={TESTS_TAB_LABEL}>
          <TestProblems projectId={projectId} />
        </Mode>
        <Mode mode={Problems.BUILD_PROBLEMS} label={BUILD_PROBLEMS_TAB_LABEL} isDisabled>
          <BuildProblems projectId={projectId} buildProblems={buildProblems} />
        </Mode>
        <Mode
          mode={Problems.BUILD_CONFIGURATION_PROBLEMS}
          label={BUILD_CONFIGURATION_PROBLEMS_TAB_LABEL}
          isDisabled
        >
          <BuildTypeProblems projectId={projectId} buildTypes={buildTypes} />
        </Mode>
      </ModeSwitch>
    </>
  )
}

export default ProjectProblemsTab
